import React, { useState, useEffect } from "react";
import api from "../../api";
import Select from "react-select";
import { FaDownload, FaSearch } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../StudentIdCardPage.css";

const TeacherIdCardPage = () => {
  const [form, setForm] = useState({ class_id: null, section_id: null });
  const [teachers, setTeachers] = useState([]);


  const [loadingTeachers, setLoadingTeachers] = useState(false);
  const [downloadingId, setDownloadingId] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);

  /* ---------------- TOAST ---------------- */
  const showToast = (type, msg) =>
    toast[type](msg, { position: "top-right", autoClose: 2000 });


  /* ---------------- SEARCH TEACHERS ---------------- */
  const fetchTeachers = async () => {

    setLoadingTeachers(true);
    setTeachers([]);

    try {
      const res = await api.get(
        `/id_card/teacher/get-data`
      );

      if (res.data.success) setTeachers(res.data.data);
      else setTeachers([]);
    } catch (error) {
      showToast("error", "Failed to load teachers");
    } finally {
      setLoadingTeachers(false);
    }
  };

  /* ---------------- DOWNLOAD ID CARD (REAL DOWNLOAD) ---------------- */
  const downloadCard = async (
    id,
    teacherName,
    type = "portrait" // default
  ) => {
    try {
      setDownloadingId(id);

      const res = await api.get(
        `/id_card/teacher/view_teacher/${id}?dl=1&type=${type}`,
        {
          responseType: "blob", // 🔑 REQUIRED
        }
      );

      const blob = new Blob([res.data], { type: "image/jpeg" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${teacherName.replace(/\s+/g, "_")}_${type.toUpperCase()}_IDCARD.jpg`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      showToast("success", "ID Card downloaded");
    } catch (error) {
      console.error(error);
      showToast("error", "Download failed");
    } finally {
      setDownloadingId(null);
    }
  };
  /* ---------------- VIEW ID CARD (MODAL PREVIEW) ---------------- */
  const viewCard = async (id, type = "portrait") => {
    try {
      setPreviewLoading(true);

      const res = await api.get(
        `/id_card/teacher/view_teacher/${id}?type=${type}`
      );

      if (res.data.success && res.data.image_url) {
        setPreviewUrl(res.data.image_url); // 🔑 DIRECT URL
      } else {
        showToast("error", "Invalid preview response");
      }

    } catch (error) {
      console.error(error);
      showToast("error", "Failed to preview ID Card");
    } finally {
      setPreviewLoading(false);
    }
  };



  /* ---------------- JSX ---------------- */
  return (
    <div className="id-container">
      <ToastContainer />

      <h2 className="title">Student ID Card Generator</h2>

      {/* FILTER */}
      <div className="filter-card">
        <div className="row">

          {/* SEARCH BUTTON */}
          <div className="col action">
            <button
              className="btn-primary"
              onClick={fetchTeachers}
              disabled={loadingTeachers}
              style={{
                opacity: loadingTeachers ? 0.7 : 1,
                cursor: loadingTeachers ? "not-allowed" : "pointer",
              }}
            >
              <FaSearch />
              {loadingTeachers ? " Searching..." : " Search Teachers"}
            </button>
          </div>
        </div>
      </div>

      {/* STUDENT TABLE */}
      <div className="list-card">
        <h4 className="list-title">Teacher List</h4>

        {loadingTeachers && (
          <div style={{ textAlign: "center", padding: "20px" }}>
            Loading teachers...
          </div>
        )}

        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Photo</th>
              <th>Name</th>
              <th>Department</th>
              <th>Father</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {!loadingTeachers && teachers.length === 0 && (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  No teachers found
                </td>
              </tr>
            )}

            {teachers.map((teacher, i) => (
              <tr key={teacher.id}>
                <td>{i + 1}</td>
                <td>
                  <img src={`https://dgps.co.in/${teacher.photo}`} className="student-img" alt="" />
                </td>
                <td>{teacher.name}</td>
                <td>{teacher.department}</td>
                <td>{teacher.father_name}</td>
                <td>
                  {/* VIEW BUTTON */}
                  <button
                    className="btn-view"
                    style={{ marginBottom: "6px" }}
                    onClick={() => viewCard(teacher.id, "portrait")}
                  >
                    👁 View ID Card
                  </button>
                  <button
                    className="btn-download"
                    disabled={downloadingId === teacher.id}
                    style={{
                      opacity: downloadingId === teacher.id ? 0.6 : 1,
                      cursor: downloadingId === teacher.id ? "not-allowed" : "pointer",
                    }}
                    onClick={() =>
                      downloadCard(teacher.id, teacher.name, teacher.teacher_code, "portrait")
                    }
                  >
                    <FaDownload />{" "}
                    {downloadingId === teacher.id ? "Downloading..." : "Download Portrait"}
                  </button>
                  {/* <button
                    className="btn-download"
                    disabled={downloadingId === teacher.id}
                    style={{
                      opacity: downloadingId === teacher.id ? 0.6 : 1,
                      cursor: downloadingId === teacher.id ? "not-allowed" : "pointer",
                    }}
                    onClick={() =>
                      downloadCard(teacher.id, teacher.name, teacher.teacher_code, "landscape")
                    }
                  >
                    <FaDownload />{" "}
                    {downloadingId === teacher.id ? "Downloading..." : "Download Landscape"}
                  </button> */}

                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* ================= PREVIEW MODAL ================= */}
        {previewUrl && (
          <div className="preview-modal">
            <div className="preview-box">

              <button
                className="close-btn"
                onClick={() => setPreviewUrl(null)}
              >
                ✖
              </button>

              {previewLoading ? (
                <div className="loading">Loading preview...</div>
              ) : (
                <img
                  src={previewUrl}
                  alt="ID Card Preview"
                  style={{ width: "100%", borderRadius: "6px" }}
                />
              )}

            </div>
          </div>
        )}


      </div>
    </div>

  );
};

export default TeacherIdCardPage;
